/**
 * You can register global mixins here
 */

const GlobalMixins = {
    install(app) {
        app.mixin({
            mounted() {
                let {
                    bodyClass
                } = this.$options;
                if (bodyClass) {
                    bodyClass.split(',').map( x => {
                    document.body.classList.add(x);
                    })
                }
            },
            beforeUnmount() {
                let {
                    bodyClass
                } = this.$options;
                if (bodyClass) {
                    bodyClass.split(',').map( x => {
                    document.body.classList.remove(x);
                    })
                }
            }
        })
    }
}
export default GlobalMixins
